import classNames from "classnames";

const dynasties = {
    164790: "tang",
    158363: "song",
    158364: "yuan",
    158365: "ming",
    2127206: "tang",
    2127207: "song",
    2127208: "yuan",
    2127209: "ming"
}

//The different dynasties is upgrades, we just check which dynasty is the latest one researched and blindly assume that is the active dynasty
export function ChinaDynasty({ allUpgrades, civilzation, leftSide }) {
    let upgradesRequired = [];
    if (civilzation === "Chinese") {
        upgradesRequired = [164790, 158363, 158364, 158365];
    }
    else if (civilzation === "Zhu Xi's Legacy") {
        upgradesRequired = [2127206, 2127207, 2127208, 2127209]; 
    } else {
        return (<></>)
    }

    let dynastyUpgrades = Object.values(allUpgrades || [])?.filter(upgrade => upgradesRequired?.includes((parseInt(upgrade))))
    let currentDynasty = dynastyUpgrades?.[dynastyUpgrades.length - 1] || upgradesRequired[0];
    let icon = `/liveGameIcons/unique/${dynasties[currentDynasty]}.png`;

    return (
        <div className={classNames('liveGameWinCondition px-2 h-[21px] flex', leftSide ? 'flex-row' : 'flex-row-reverse')} style={{ flex: '0 0 auto', background: 'linear-gradient(90deg,rgba(29, 39, 47, 0.0) 0%, rgba(29, 39, 47, 1) 10%, rgba(29, 39, 47, 1) 90%, rgba(29, 39, 47, 0.0) 100%)' }}>
            <img src={icon} className='w-[21px]' alt={``} />
            <h1 className="capitalize text-white px-1">{dynasties[currentDynasty]} Dynasty</h1>
        </div>
    )
}